/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';

/**
 * 
 * @export
 * @interface GeometryLabelDto
 */
export interface GeometryLabelDto {
    /**
     * 
     * @type {number}
     * @memberof GeometryLabelDto
     */
    id: number | null;
    /**
     * 
     * @type {string}
     * @memberof GeometryLabelDto
     */
    name?: string | null;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof GeometryLabelDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {string}
     * @memberof GeometryLabelDto
     */
    $type?: GeometryLabelDtoTypeEnum;
}


/**
 * @export
 */
export const GeometryLabelDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoGeometryLabelDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.GeometryLabelDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type GeometryLabelDtoTypeEnum = typeof GeometryLabelDtoTypeEnum[keyof typeof GeometryLabelDtoTypeEnum];



/**
 * Check if a given object implements the GeometryLabelDto interface.
 */
export function instanceOfGeometryLabelDto(value?: unknown): value is GeometryLabelDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(GeometryLabelDtoTypeEnum)[0];
}

export function GeometryLabelDtoFromJSON(json: any): GeometryLabelDto {
    return GeometryLabelDtoFromJSONTyped(json, false);
}

export function GeometryLabelDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeometryLabelDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function GeometryLabelDtoToJSON(value?: GeometryLabelDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'name': value['name'],
        'origin': EntityOriginToJSON(value['origin']),
        '$type': value['$type'],
    });
}

